import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { DynamicFormConfig } from "../types/dynamic-form-config";

import { FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.sass']
})
export class DynamicFormComponent implements OnInit, OnChanges {
  @Input() config: DynamicFormConfig[] = [];
  @Output() save = new EventEmitter();
  form = new FormGroup({});

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.config.forEach((control) =>
      control.name.forEach(name => {
        this.form.addControl(
          name,
          new FormControl(control.initialValue, control.validation)
        )
        control.disabled ? this.form.get(control.name)?.disable() : this.form.get(control.name)?.enable();
      })
    );
  }

  submit() {
    if (this.form.errors == null) {
      this.save.emit(this.form);
      this.form.markAsPristine();
    } else {
      this.form.markAllAsTouched();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.form = new FormGroup({});
    this.createForm();
  }
}
